/*
 * @Author: 李聪
 * @Date: 2021-08-20 13:49:15
 * @LastEditors: 李聪
 * @LastEditTime: 2021-08-23 10:30:07
 * @Description: 企业动态入口
 */
import { createApp } from "vue";
import ProgrammeDetail from "./ProgrammeDetail.vue";
import "@/styles/global.less";

createApp(ProgrammeDetail).mount("#app");